import React from "react";
import HistoryTCSearchForm from "./shared/history-tc-search-form.jsx";
import HistoryTCList from "./shared/history-tc-list.jsx";
import ajax from "./../lib/ajax.js";
import context from "./../lib/context.js";
import immutable from "immutable";

export default class PeopleHistoryTC extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchForm: {
                timecardStatusList: [],
                companies: [],
                peopleList: [],
                selectedStatus: ""
            },
            timecardList: {
                timecards: [],
                total: 0 
            }
        }

        this.onTimecardStatusSelectionChange = this.onTimecardStatusSelectionChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
        this.search = this.search.bind(this);
        this.getTimecardUrl = this.getTimecardUrl.bind(this);
    }

    componentDidMount() {
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });

        this.loadViewModel();
    }

    onTimecardStatusSelectionChange(newStatus) {
        let clone = immutable.fromJS(this.state.search).toJS();
        clone.timecardStatus = newStatus;
        clone.page = 0;
        this.setState({search: clone}, this.search);
    }

    onNavigate(page) {
        let clone = immutable.fromJS(this.state.search).toJS();
        clone.page = page;
        this.setState({search: clone}, this.search);
    }

    onSearch(payload) {
        let clone = immutable.fromJS(this.state.searchForm).toJS();
        clone.selectedStatus = payload.timecardStatus;
        payload.page = this.state.search.page;
        payload.pageSize = this.state.search.pageSize;
        this.setState({search: payload, searchForm: clone}, this.search);
    }

    search() {
        let self = this;                
        let vm = self.state;        
        context.message({show:true, type: "loading", message:"Loading. Please wait..."});
        ajax.api().get("get-timecard-by-status/people/" + vm.search.timecardStatus + "/" + vm.search.monthEnding, {
            params : {                                     
                assocName: vm.search.employeeName, 
                office: vm.search.office,
                company: vm.search.company,
                p: vm.search.page,
                pz: vm.search.pageSize
            }
        })
        .then(function(res) {
            res.data.page = vm.search.page;
            res.data.pageSize = vm.search.pageSize;
            self.setState({timecardList: res.data});                 
            context.message({show:false});
        })
        .catch(function(err) {
            let data = err.response.data;
            context.message({
                show: true,
                type: "error",
                message: data.exceptionMessage || data.message,
                buttons: "close"
            });
        });
    }

    loadViewModel() {
        const self = this;
        ajax.vm()
            .get("people/history-tc")
            .then(function (res) {
                let data = res.data;
                data.search = {page: 0, pageSize: 10};
                self.setState(res.data, self.refs.searchForm.onSearch);
                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                if (data.message.toLowerCase().indexOf("unauthorize") > -1)
                    window.location = context.root() + `/../AccessDenied.aspx`;
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
    }

    getTimecardUrl(timecard) { // expected type: TimecardSummary
        return context.routeUrl(`people/history-tc-entry/${timecard.timecardId}`);
    }

    render() {
        const self = this;
        console.log(self.state);
        let idx = 0;
        let idx2 = 0;
        return (
            <div className="container">
                <div className="row hidden-sm hidden-xs">
                    <div className="col-md-12">
                        <h2 className="text-center ap-title">Timecard History</h2>
                        <h3 className="text-center ap-sub-title">View Timecard History</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <HistoryTCSearchForm vm={self.state.searchForm} onSearch={this.onSearch} onTimecardStatusSelectionChange={this.onTimecardStatusSelectionChange} 
                            hideFilters="people,company,office" ref="searchForm" />
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-md-12">
                        <HistoryTCList vm={self.state.timecardList} role="people" hideColumns="people"
                            onNavigate={this.onNavigate} onGetItemUrl={this.getTimecardUrl} />
                    </div>
                </div>
            </div>
        );
    }
}